import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import DatePicker from "react-datepicker";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Moment from "moment";
import ConfirmDialog from "../components/ConfirmDialog";
import PopupMessage from "../components/PopupMessage";
import "react-datepicker/dist/react-datepicker.css";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import DeleteIcon from "@material-ui/icons/DeleteForeverOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import AddPolicyIcon from "@material-ui/icons/LoupeOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import CustomTableHead from "../components/CustomTableHead";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },

  formContent: {
    marginTop: `50px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
  },

  redCell: {
    color: "red",
  },
  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  {
    id: "companyId",
    numeric: false,
    disablePadding: true,
    label: "Company ID",
  },
  {
    id: "companyName",
    numeric: false,
    disablePadding: true,
    label: "Company Name",
  },
  { id: "code", numeric: false, disablePadding: true, label: "Code" },
  { id: "type", numeric: false, disablePadding: true, label: "Type" },
  { id: "crDr", numeric: false, disablePadding: true, label: "CR/DR" },
  {
    id: "minAmount",
    numeric: true,
    disablePadding: false,
    label: "Minimum Amount($)",
  },
  {
    id: "maxAmount",
    numeric: true,
    disablePadding: false,
    label: "Maximum Amount($)",
  },
  {
    id: "effectiveDate",
    numeric: false,
    disablePadding: true,
    label: "Effective Date",
  },
  {
    id: "expiryDate",
    numeric: false,
    disablePadding: true,
    label: "Expiry Date",
  },
  { id: "enabled", numeric: false, disablePadding: true, label: "Enabled" },
  { id: "descr", numeric: false, disablePadding: true, label: "Description" },
];

class AchPolicyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      actionError: "",
      notifyString: "",
      reply: {},
      items: [],
      selectedItemKey: -1,
      selectedItemObject: {},
      totalCount: 0,
      viewPopup: false,
      viewAdd: false,
      confirmDelete: false,
      startDate: null,
      endDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      checkA: true,
      order: "asc",
      orderBy: "0",
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseActionPopup = this.onCloseActionPopup.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  componentDidMount() {
    fetch("on_ach_policy_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        rangeId: this.props.accountObject.rangeId,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ items: reply.items });
          this.setState({ totalCount: reply.totalCount });
          this.setState({ reply: reply });

          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (orderBy === "code") {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "minAmount") {
        data.sort(getFloatSorting(order, "rowMinAmount"));
      } else if (orderBy === "maxAmount") {
        data.sort(getFloatSorting(order, "rowMaxAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      // recreate index
      let i;
      for (i = 0; i < data.length; i++) {
        data[i].index = i;
      }
      this.setState({ items: data });
    }
  }

  onCloseActionPopup(e) {
    this.setState({ actionError: "" });
    this.setState({ viewPopup: false });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewAdd: false });
    this.setState({ confirmDelete: false });
    this.setState({ selectedItemKey: -1 });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  handleAdd(event) {
    this.setState({ selectedItemObject: this.getEmptyItem() });
    this.setState({ checkA: true });
    this.setState({ startDate: null });
    this.setState({ endDate: null });
    this.setState({ viewAdd: true });
  }

  handleSelectItem(event, index) {
    if (this.state.items[index].enabled === "Y") {
      this.setState({ checkA: true });
    } else {
      this.setState({ checkA: false });
    }
    if (
      this.state.items[index].effectiveDate !== null &&
      this.state.items[index].effectiveDate.length > 0
    ) {
      this.setState({
        startDate: Moment(
          this.state.items[index].effectiveDate,
          BACKEND_DATE_FORMAT
        ),
      });
    } else {
      this.setState({ startDate: null });
    }
    if (
      this.state.items[index].expiryDate !== null &&
      this.state.items[index].expiryDate.length > 0
    ) {
      this.setState({
        endDate: Moment(
          this.state.items[index].expiryDate,
          BACKEND_DATE_FORMAT
        ),
      });
    } else {
      this.setState({ endDate: null });
    }
    this.setState({ selectedItemKey: index });
    this.setState({
      selectedItemObject: this.copyItem(this.state.items[index]),
    });
  }

  onDelete(e) {
    this.setState({ confirmDelete: true });
  }

  onSave(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let selectedObject = this.state.selectedItemObject;
    if (this.state.startDate === null) {
      this.setState({
        actionError: getErrorString(
          "ach.policy.effective.date.error",
          "Effective Date is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (selectedObject.descr === null || selectedObject.descr.length === 0) {
      this.setState({
        actionError: getErrorString(
          "ach.policy.description.error",
          "Description is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (
      this.state.endDate != null &&
      this.state.endDate.isBefore(this.state.startDate, "day")
    ) {
      this.setState({
        actionError: getErrorString(
          "ach.policy.expiry.date.error",
          "Expiry Date is before Effective Date."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }

    if (this.state.viewAdd) {
      this.executeAction(1);
    } else {
      this.executeAction(2);
    }
  }

  handleDelete(e, action) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ confirmDelete: false });
    // confirmed
    if (action === 1) {
      this.executeAction(3);
    }
  }

  executeAction(actionNumber) {
    fetch("on_ach_policy_action", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        rangeId: this.props.accountObject.rangeId,
        rangeStart: this.props.accountObject.rangeStart,
        rangeEnd: this.props.accountObject.rangeEnd,
        action: actionNumber,
        item: this.state.selectedItemObject,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ totalCount: 0 });
          this.setState({ viewAdd: false });
          this.setState({ selectedItemKey: -1 });
          this.componentDidMount();
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleStartDate(date) {
    this.setState({ startDate: date });
    let selectedObject = this.state.selectedItemObject;
    if (date === null) {
      selectedObject.effectiveDate = "";
    } else {
      selectedObject.effectiveDate = date.format(BACKEND_DATE_FORMAT);
    }
    this.setState({ selectedItemObject: selectedObject });
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.setState({ endDate: date });
    let selectedObject = this.state.selectedItemObject;
    if (date === null) {
      selectedObject.expiryDate = "";
    } else {
      selectedObject.expiryDate = date.format(BACKEND_DATE_FORMAT);
    }
    this.setState({ selectedItemObject: selectedObject });
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCompanyId(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.companyId = e.target.value;
    if (selectedObject.companyId === "") selectedObject.companyId = "ANY";
    this.setState({ selectedItemObject: selectedObject });
  }

  handleCompanyName(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.companyName = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleCode(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.code = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleType(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.type = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleCrDr(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.crDr = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleMinAmount(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.rowMinAmount = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleMaxAmount(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.rowMaxAmount = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleDescr(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.descr = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }
  handleEnable(e) {
    this.setState({ checkA: e.target.checked });
    let selectedObject = this.state.selectedItemObject;
    if (e.target.checked) {
      selectedObject.enabled = "Y";
    } else {
      selectedObject.enabled = "N";
    }
    this.setState({ selectedItemObject: selectedObject });
  }
  getEmptyItem() {
    let myItem = {
      index: 0,
      id: "0",
      bankId: "",
      companyId: "",
      companyName: "",
      code: "ANY",
      codeDescr: "",
      type: "ANY",
      typeDescr: "",
      crDr: "ANY",
      minAmount: "",
      rowMinAmount: "",
      maxAmount: "",
      rowMaxAmount: "",
      effectiveDate: "",
      expiryDate: "",
      enabled: "Y",
      descr: "",
      anyCompany: true,
    };
    return myItem;
  }

  copyItem(item) {
    let myItem = this.getEmptyItem();
    myItem.index = item.index;
    myItem.id = item.id;
    myItem.bankId = item.bankId;
    myItem.companyId = item.companyId;
    myItem.companyName = item.companyName;
    myItem.code = item.code;
    myItem.codeDescr = item.codeDescr;
    myItem.type = item.type;
    myItem.typeDescr = item.typeDescr;
    myItem.crDr = item.crDr;
    myItem.minAmount = item.minAmount;
    myItem.rowMinAmount = item.rowMinAmount;
    myItem.maxAmount = item.maxAmount;
    myItem.rowMaxAmount = item.rowMaxAmount;
    myItem.effectiveDate = item.effectiveDate;
    myItem.expiryDate = item.expiryDate;
    myItem.enabled = item.enabled;
    myItem.descr = item.descr;
    myItem.anyCompany = item.anyCompany;
    return myItem;
  }

  isSelected = (id) => this.state.selectedItemKey === id;
  render() {
    const { classes } = this.props;
    const { order, orderBy } = this.state;
    let data = this.state.items;
    let codes = this.state.reply.transCodes;
    let classCodes = this.state.reply.classCodes;
    let { t } = this.props;
    return (
      <div id="myTopDiv">
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.confirmDelete && (
          <ConfirmDialog
            title={t("confirmDelete.label")}
            text={t("deleteAchPolicy.label")}
            onCloseConfirm={this.handleDelete}
          />
        )}
        {this.state.viewPopup && this.state.actionError.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.actionError}
            error={true}
            onClosePopup={this.onCloseActionPopup}
          />
        )}

        <div className={classes.toolbar}>
          {!this.state.viewAdd && this.state.selectedItemKey === -1 && (
            <FormGroup row>
              <Typography variant="h6" color="primary">
                &nbsp;&nbsp;{t("achPolicies.label")}:&nbsp;&nbsp;
              </Typography>
              {this.state.reply.canCreate && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleAdd(event)}
                >
                  <AddPolicyIcon />
                  &nbsp;{t("addPolicy.label")}
                </Button>
              )}
            </FormGroup>
          )}
          {this.state.viewAdd && (
            <FormGroup row>
              <Typography variant="headline" color="textSecondary">
                &nbsp;&nbsp; {t("newAchPolicy.label")}: &nbsp;&nbsp;
              </Typography>
              <Button color="primary" onClick={(event) => this.onSave(event)}>
                <SaveIcon />
                &nbsp;{t("save.button")}
              </Button>
              <Button
                color="primary"
                onClick={(event) => this.onClosePopup(event)}
              >
                <CancelIcon />
                &nbsp;{t("cancel.button")}
              </Button>
            </FormGroup>
          )}
          {this.state.selectedItemKey !== -1 && (
            <FormGroup row>
              <Typography variant="headline" color="textSecondary">
                &nbsp;&nbsp; {t("selectedAchPolicy.label")}: &nbsp;&nbsp;
              </Typography>
              <Button
                color="primary"
                onClick={(event) => this.onClosePopup(event)}
              >
                <DeselectIcon />
                &nbsp;{t("deselect.button")}
              </Button>
              {this.state.reply.canUpdate && (
                <Button color="primary" onClick={(event) => this.onSave(event)}>
                  <SaveIcon />
                  &nbsp;{t("save.button")}
                </Button>
              )}
              {this.state.reply.canDelete && (
                <Button
                  color="primary"
                  onClick={(event) => this.onDelete(event)}
                >
                  <DeleteIcon />
                  &nbsp;{t("delete.button")}
                </Button>
              )}
            </FormGroup>
          )}

          <Divider />
        </div>

        <div className={classes.tableWrapper}>
          {(this.state.viewAdd || this.state.selectedItemKey !== -1) && (
            <div>
              <FormGroup row>
                <TextField
                  margin="dense"
                  id="companyId"
                  label={t("compId.label")}
                  type="text"
                  defaultValue={this.state.selectedItemObject.companyId}
                  onChange={(event) => this.handleCompanyId(event)}
                  onKeyPress={(event) => {
                    return event.charCode >= 48 && event.charCode <= 57
                      ? true
                      : event.preventDefault();
                  }}
                />
                &nbsp;&nbsp;
                <TextField
                  margin="dense"
                  id="companyName"
                  label={t("companyName.header")}
                  type="text"
                  defaultValue={this.state.selectedItemObject.companyName}
                  onChange={(event) => this.handleCompanyName(event)}
                />
                <div style={{ margin: 10 }}>
                  <Typography variant="caption">{t("code.label")}</Typography>
                  &nbsp;&nbsp;
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 44,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.selectedItemObject.code}
                      input={<Input id="code" />}
                      onChange={(event) => this.handleCode(event)}
                    >
                      {codes.map((n) => {
                        return <option value={n.code}>{n.code}</option>;
                      })}
                    </NativeSelect>
                  </FormControl>
                </div>
                <div style={{ margin: 10 }}>
                  <Typography variant="caption">{t("type.label")}</Typography>
                  &nbsp;&nbsp;
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 44,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.selectedItemObject.type}
                      input={<Input id="type" />}
                      onChange={(event) => this.handleType(event)}
                    >
                      {classCodes.map((n) => {
                        return <option value={n.code}>{n.code}</option>;
                      })}
                    </NativeSelect>
                  </FormControl>
                </div>
                <div style={{ margin: 10 }}>
                  <Typography variant="caption">
                    {t("creditDebit.label")}
                  </Typography>
                  &nbsp;&nbsp;
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 44,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.selectedItemObject.crDr}
                      input={<Input id="crdr" />}
                      onChange={(event) => this.handleCrDr(event)}
                    >
                      <option value={this.state.reply.any}>
                        {this.state.reply.any}
                      </option>
                      <option value="CR">{t("credit.label")}</option>
                      <option value="DR">{t("debit.label")}</option>
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;
                </div>
              </FormGroup>
              <FormGroup row>
                <TextField
                  id="amountFrom"
                  label={t("minAmount.label")}
                  defaultValue={this.state.selectedItemObject.rowMinAmount}
                  onChange={(event) => this.handleMinAmount(event)}
                  InputProps={{
                    inputComponent: AmountFormatCustom,
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                &nbsp;&nbsp;
                <TextField
                  id="amountTo"
                  label={t("maxAmount.label")}
                  defaultValue={this.state.selectedItemObject.rowMaxAmount}
                  onChange={(event) => this.handleMaxAmount(event)}
                  InputProps={{
                    inputComponent: AmountFormatCustom,
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                &nbsp;&nbsp;
                <div style={{ height: 48, marginTop: 30 }}>
                  <Typography variant="caption">
                    {t("effectiveDate.label")}&nbsp;&nbsp;
                    {!this.state.redrawStartDate && (
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        fixedHeight
                        popperModifiers={{
                          preventOverflow: {
                            enabled: true,
                          },
                        }}
                        selected={this.state.startDate}
                        onChange={(event) => this.handleStartDate(event)}
                        onClickOutside={(event) =>
                          this.handleStartDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    )}
                  </Typography>
                </div>
                &nbsp;&nbsp;
                <div style={{ height: 48, marginTop: 30 }}>
                  <Typography variant="caption">
                    {t("expireDate.label")}&nbsp;&nbsp;
                    {!this.state.redrawEndDate && (
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        fixedHeight
                        popperModifiers={{
                          preventOverflow: {
                            enabled: true,
                          },
                        }}
                        selected={this.state.endDate}
                        onChange={(event) => this.handleEndDate(event)}
                        onClickOutside={(event) =>
                          this.handleEndDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    )}
                  </Typography>
                </div>
              </FormGroup>
              <FormGroup row>
                <TextField
                  margin="dense"
                  id="descr"
                  label={t("description.header")}
                  type="text"
                  required
                  defaultValue={this.state.selectedItemObject.descr}
                  onChange={(event) => this.handleDescr(event)}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div style={{ marginTop: 15 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.checkA === true}
                        onChange={(event) => this.handleEnable(event)}
                        value="checkA"
                        color="default"
                      />
                    }
                    label={t("enable.label")}
                  />
                </div>
              </FormGroup>
            </div>
          )}

          {!this.state.viewAdd &&
            this.state.selectedItemKey === -1 &&
            this.state.totalCount > 0 && (
              <div>
                <Paper>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />

                    <TableBody>
                      {data.map((n) => {
                        const isSelected = this.isSelected(n.index);
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectItem(event, n.index)
                            }
                            key={n.index}
                            selected={isSelected}
                          >
                            <TableCell>
                              {n.anyCompany
                                ? this.state.reply.any
                                : n.companyId}
                            </TableCell>
                            <TableCell>{n.companyName}</TableCell>
                            <Tooltip title={n.codeDescr}>
                              <TableCell>{n.code}</TableCell>
                            </Tooltip>
                            <Tooltip title={n.typeDescr}>
                              <TableCell>{n.type}</TableCell>
                            </Tooltip>
                            <TableCell>
                              {n.crDr === "DR"
                                ? t("debit.label")
                                : n.crDr === "CR"
                                ? t("credit.label")
                                : n.crDr}
                            </TableCell>
                            <TableCell>{n.minAmount}</TableCell>
                            <TableCell>{n.maxAmount}</TableCell>
                            <TableCell>{n.effectiveDate}</TableCell>
                            <TableCell>{n.expiryDate}</TableCell>
                            <TableCell>{n.enabled}</TableCell>
                            <Tooltip title={n.descr}>
                              <TableCell>{n.descr}</TableCell>
                            </Tooltip>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
        </div>
      </div>
    );
  }
}

AchPolicyPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(AchPolicyPage));
